import { toastTypes } from './types';

export const showToast = () => {
  return dispatch => {
    dispatch({
      type: toastTypes.SHOW_TOAST
    })
  }
}